import React, { FC, useEffect, useState } from 'react';

import MovingPaymentForm from './movingPaymentForm';
import MovingHistoryTable from './movingHistoryTable';
import { IMovingPaymentProps } from './interfaces';
import { IMovingHistory, Payment } from '@/types/payment';
import { getMovePaymentHistory } from '@api/payment';
import { moment } from '@utils/date';

const MovingPayment: FC<IMovingPaymentProps> = ({ payment }) => {
  const [movingHistory, setMovingHistory] = useState<IMovingHistory[]>([]);

  const sortyByDate = (data: IMovingHistory[]) => {
    return data.sort((a, b) => {
      const isAfter = moment(a.date).isAfter(b.date);
      return isAfter ? -1 : 1;
    });
  };

  const handleUpdateTable = (payment: Payment) => {
    if (movingHistory) {
      setMovingHistory(sortyByDate(payment.movingHistory));
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const data = await getMovePaymentHistory({ id: payment.id });
        setMovingHistory(sortyByDate(data));
      } catch (error) {
        console.log('error', error);
      }
    })();
  }, [payment]);

  return (
    <>
      <MovingPaymentForm payment={payment} onSubmit={handleUpdateTable} />
      <MovingHistoryTable data={movingHistory} />
    </>
  );
};

export default MovingPayment;
